Vue.component('content-pricing', {
    delimiters: ['[[', ']]'],
    template: `
        <div>
            <div class="row">

                <div class="lqd-column col-md-12">

                    <header class="fancy-title text-center mb-90">
                        <h6 class="text-uppercase">Pricing plan</h6>
                        <h2><strong>Affordable</strong> pricing</h2>
                    </header>

                </div><!-- /.lqd-column col-md-12 -->

                </div><!-- /.row -->

                <div class="row mx-md-0">

                    <div class="lqd-column col-md-2 px-md-0"></div>

                <!-- <div class="lqd-column col-md-6 px-md-0">

                    <div class="pricing-table pricing-table-agency">
                        <div class="pricing-table-header">
                            <figure class="mb-7 loaded">
                                <img src="./assets/demo/misc/pricing-table-1.png" alt="Personal Plan" />
                            </figure>
                            <h5>Personal</h5>
                            <p class="pricing">Free</p>
                        </div>
                        <div class="pricing-table-body">
                            <ul>
                                <li>Desktop application</li>
                                <li></li>
                            </ul>
                        </div>
                        <div class="pricing-table-footer">
                            <a href="#downloadModal" class="btn btn-default text-uppercase btn-sm circle btn-solid border-thin font-size-14 font-weight-bold ltr-sp-05 px-2" data-lity="#downloadModal">
                                <span>
                                    <span class="btn-txt">Get started now</span>
                                </span>
                            </a>
                        </div>
                    </div>

                </div> -->

                <!-- <div class="lqd-column col-md-4 px-md-0">

                    <div class="pricing-table pricing-table-agency featured">
                        <span class="pricing-table-featured-label font-weight-bold text-uppercase ltr-sp-25"><span>Popular</span></span>
                        <div class="pricing-table-header">
                            <figure class="mb-7 loaded">
                                <img src="./assets/demo/misc/pricing-table-2.png" alt="Small Team Plan" />
                            </figure>
                            <h5>Small Team</h5>
                            <p class="pricing">Contact us</p>
                        </div>
                        <div class="pricing-table-body">
                            <ul>
                                <li>Desktop application</li>
                                <li>Cloud access</li>
                            </ul>
                        </div>
                        <div class="pricing-table-footer">
                            <a href="#" class="btn btn-default text-uppercase btn-sm circle btn-solid border-thin font-size-14 font-weight-bold ltr-sp-05 px-2">
                                <span>
                                    <span class="btn-txt">Get started now</span>
                                </span>
                            </a>
                        </div>
                    </div>

                </div> -->

                <div class="lqd-column col-md-4 px-md-0">

                    <div class="pricing-table pricing-table-agency">
                        <div class="pricing-table-header">
                            <figure class="mb-7 loaded">
                                <!-- <img src="./assets/demo/misc/pricing-table-3.png" alt="Small Team Plan" /> -->
                                <img class="logo-default" src="./assets/img/spartaquant/icon-color.png" width="180px" alt="SpartaQuant icon">
                            </figure>
                            <h5>Public solution</h5>
                            <p class="pricing">Free</p>
                        </div>
                        <div class="pricing-table-body">
                            <ul>
                                <li>Web-based solution</li>
                                <li>Housed on <strong class="sq-font">SpartaQuant</strong>'s servers</li>
                                <li>Limited number of queries</li>
                            </ul>
                        </div><!-- /.pricing-table-body -->
                        <div class="pricing-table-footer">
                            <a href="#contactBetaTester" class="btn btn-default text-uppercase btn-sm circle btn-bordered border-thin font-size-14 font-weight-bold ltr-sp-05 px-2" data-lity="#contactEnterprice">
                                <span>
                                    <span class="btn-txt">Become a beta tester</span>
                                </span>
                            </a>
                        </div><!-- /.pricing-table-footer -->
                    </div><!-- /.pricing-table -->

                </div><!-- /.lqd-column col-md-4 px-md-0 -->

                <div class="lqd-column col-md-1 px-md-0"></div>

                <div class="lqd-column col-md-4 px-md-0">

                    <div class="pricing-table pricing-table-agency">
                        <div class="pricing-table-header">
                            <figure class="mb-7 loaded">
                                <!-- <img src="./assets/demo/misc/pricing-table-3.png" alt="Small Team Plan" /> -->
                                <img class="logo-default" src="./assets/img/spartaquant/icon-color.png" width="180px" alt="SpartaQuant icon">
                            </figure>
                            <h5>Enterprise solution</h5>
                            <p class="pricing">Contact us</p>
                        </div>
                        <div class="pricing-table-body">
                            <ul>
                                <li>Cluster-based deployment</li>
                                <li>Custom integration</li>
                                <li><strong class="sq-font">SpartaQuant</strong> is securely imbedded within your environment</li>
                            </ul>
                        </div><!-- /.pricing-table-body -->
                        <div class="pricing-table-footer">
                            <a href="#contactEnterprice" class="btn btn-default text-uppercase btn-sm circle btn-bordered border-thin font-size-14 font-weight-bold ltr-sp-05 px-2" data-lity="#contactEnterprice">
                                <span>
                                    <span class="btn-txt">Contact us</span>
                                </span>
                            </a>
                        </div><!-- /.pricing-table-footer -->
                    </div><!-- /.pricing-table -->

                </div><!-- /.lqd-column col-md-4 px-md-0 -->

            </div><!-- /.row mx-md-0 -->
        </div>
    `,
    props: {
        idcomponent: {
            type: String,
            default: 'menu'
        },
    },
    data: function () {
        return {
            menuType: 1,
        }
    },
    mounted(){

    },
    methods: {
        downloadForm: function(){
            app.downloadForm();
        }
    },
});